export default {
    HOME: {
        // CALENDAR: {
        //     href: '/events/calendar',
        //     className: 'calendar',
        //     translationKey: 'navbar_calendar'
        // }
    }
};